/* Button style override */

button.af-mutex {
  i.fas, i.far {
    @extend .fa-fw !optional;
  }

  &--executing {
    i.fas, i.far {
      @extend .fas, .fa-spinner, .fa-spin !optional;
    }
  }

  &--disabled:not(.af-mutex--executing) {
    @extend .disabled !optional;
    pointer-events: none;
  }
}
